import { event, config } from 'vue-gtag'

export default class ApiGtag {
  public static sendEvent(
    category: string,
    action: string,
    label: string
  ): void {
    event(action, {
      event_category: category,
      event_label: label
    })
  }

  public static setConfig(language: string, user_id: string): void {
    config({
      language,
      user_id
    })
  }
}

export enum Category {
  Course = 'Course',
  Project = 'Project',
  Search = 'Search',
  User = 'User',
  Help = 'Help'
}
